/**
 * @generated SignedSource<<8c99f672e1e1b18e5456745ddd4e166d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ScalarField",
    "name": "ShareSponsorCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareSponsorCodeModalMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareSponsorCodeModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9587a536d52739a02a72f8477bbc2d7e",
    "id": null,
    "metadata": {},
    "name": "ShareSponsorCodeModalMutation",
    "operationKind": "mutation",
    "text": "mutation ShareSponsorCodeModalMutation(\n  $email: String!\n) {\n  ShareSponsorCode(email: $email)\n}\n"
  }
};
})();

node.hash = "68ec2f70974326673dde065cb8880c78";

module.exports = node;
